import { type Repub } from '@cx-modules/constants';

import { REPUB_CONFIG } from '~/repub-config';

export const getPlusLinks = ({
  isTipstersEnabled,
  repub,
  urlPrefix,
}: {
  isTipstersEnabled: boolean;
  repub: Repub;
  urlPrefix: string;
}) => {
  const links = REPUB_CONFIG[repub]?.plus?.navigation?.plusLinks(urlPrefix) ?? [];

  return links.filter(link => {
    if (link.showWhenTipstersEnabled === true) return isTipstersEnabled; // Show tipsters link when the feature flag is enabled.
    if (link.showWhenTipstersEnabled === false) return false; // Explicitly disable tipsters for this repub.
    return true; // No tipsters setting (undefined) - always show the link.
  });
};
